{
  "header": "Asset Details",
  "subtitle": "The asset attached to your truck (trailer, container, etc).",
  "assetType": "Asset Type",
  "assetTypePlaceholder": "Select the Asset type",
  "assetId": "Asset ID (e.g. Trailer Number)",
  "assetIdPlaceholder": "E.g: Trailer number, Container ID, etc",
  "remove": "Remove",
  "addAnother": "Add another asset",
  "trailerType": "Trailer type",
  "trailerId": "Trailer ID"
}
